import styled, { css } from "styled-components";
import { Center, Scroll, Shadow } from "styles/GlobalCss";
import { bg } from "styles/theme";
import { gTheme, gray, ligthGray, primary, secondary, white } from "styles/theme";

export const WrapAssessmentSection = styled.div`


`

export const C = styled.div`

`

export const WrapSelectAssessment = styled.div`
width: 30px;
position: relative;
left: 13px;
top: 17px;
`

export const WrapAssessment = styled.div`
display: flex;
flex-direction: column;
height:100%;

// position: relative;
// bottom: 15px;
`

export const WrapHeader = styled.div`

`

export const SelectAssessment = styled.div`
left: 10px !important;
position: relative !important;
top: 10px !important;
width:20px;
height:20px;
border:2px solid ${gray};
border-radius: 30px;
background: white;
${Center};
${Shadow};
cursor:pointer;

`

export const Row = css`
display:flex;
height:40px;
width: 100%;
justify-content: space-between;
align-items: center;
box-sizing:border-box;
`

export const ItemWithBorder = css`
border: 1px solid ${ligthGray};
border-radius: 4px;
padding: 8px;
font-size:13px;
background: ${props => props.$bg ? gTheme[props.$bg].main : white};
`

export const WrapAssessmentDefsItems = styled.div`
overflow:auto;
display:grid;
height:100%;
flex-grow:1;
grid-template-columns: repeat(auto-fill, 300px);
grid-column-gap: 20px;
grid-row-gap: 20px;
box-sizing: border-box;
justify-content: center;
${Scroll};
`

export const WrapHeaderActions = styled.div`
margin-top:5px;
.assessment-def-search{
width:300px;

}
`

export const WrapTitle = styled.div`
${Row};

.type-and-c{
display:flex;
column-gap:10px;
align-items:center;
}
`

export const AssessmentName = styled.div`
font-weight: bold;
font-size: 20px;
`

export const WrapContent = styled.div`
flex-grow:1;
align-items: center;
display:flex;
`

export const WrapFooter = styled.div`
${Row};

`

export const Method = styled.div`
${ItemWithBorder};

background:${bg};
`

export const WordsLength = styled.div`
${ItemWithBorder};
`

export const Type = styled.div`
${ItemWithBorder};
`

export const Semester = styled.div`
${ItemWithBorder};
`
